import React, { memo } from "react";
import colors from "app/colors";
import { FileDownloadIcon } from "modules/icons";
import CircularIconButton from "../_shared/buttons/circular-icon-button";
import { FileGalleryFragment } from "gql/graphql";
import useDownloadFile from "modules/hooks/use-download-file";
import {
  FILE_GALLERY_BUTTON_BOX_SIZE,
  FILE_GALLERY_BUTTON_BACKGROUND_COLOR,
  FILE_GALLERY_BUTTON_WIDTH,
} from "modules/utils/Constants";
import { VStack, Text } from "@chakra-ui/react";

interface IProps {
  file: FileGalleryFragment;
}

const FileGalleryDownloadButton = ({ file }: IProps) => {
  const { downloadFile } = useDownloadFile(file);

  return (
    <VStack spacing={1} w={FILE_GALLERY_BUTTON_WIDTH}>
      <CircularIconButton
        icon={
          <FileDownloadIcon
            fill={colors.white}
            boxSize={
              FILE_GALLERY_BUTTON_BOX_SIZE - 1
            } /*this icon not like the others so, -1*/
          />
        }
        onClick={downloadFile}
        aria-label="download"
        backgroundColor={FILE_GALLERY_BUTTON_BACKGROUND_COLOR}
        variant="hover"
      />
      <Text color={colors.grayPrimary} fontWeight={500} fontSize={10}>
        Download
      </Text>
    </VStack>
  );
};

export default memo(FileGalleryDownloadButton);
